import { useMemo } from 'react';
import home from '~/assets/icons/home.svg';
import map from '~/assets/icons/map.svg';
import task from '~/assets/icons/task_2.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { SpawnPointType } from '~/shared';
import { StyledContainer } from './Spawn.styled';

const Spawn = ({
	index,
	name,
	type,
}: {
	index: number;
	name: string;
	type: SpawnPointType;
}) => {
	const spawnIcon = useMemo(() => {
		switch (type) {
			case SpawnPointType.ESTATE:
				return home;
			case SpawnPointType.ACTIVE_QUEST:
				return task;
			case SpawnPointType.LAST_POSITION:
				return map;
		}
	}, [type]);

	return (
		<StyledContainer
			onMouseEnter={() => {
				playSound(Sound.LinkCursor);
				rage.spawnSelect
					.setSpawnPointIndex(index)
					.catch((err) => rage.notifications.showException(err));
			}}
			onClick={() => {
				playSound(Sound.ClickButton);
				rage.spawnSelect
					.setSpawnPointIndex(index)
					.then(() => rage.spawnSelect.selectActiveSpawnPoint())
					.catch((err) => rage.notifications.showException(err));
			}}
		>
			<img src={spawnIcon} />
			<Text>{name}</Text>
		</StyledContainer>
	);
};

export { Spawn };
